import AccountAlertsView from './AccountAlerts.view';

export default AccountAlertsView;
